// Whole-contact wrap-up summary (backlog row 125, Storm 2026-10-21).
//
// At wrap-up the console asks knktr-contact-summary for one summary of the
// whole call: Reason for call, AI assistant, Agent, Outcome, Next actions.
// The server reads the transcript itself; the console sends only the contact
// id. Pure helpers here so scripts/verify-contact-summary-console.mjs can
// prove the rules without a browser.

// The notes box takes the summary ONLY when it holds nothing of the agent's
// own: empty, or still exactly the bot-leg summary it was seeded with
// (lib/wrapupNotes.js), or exactly a summary this console already put there.
// Anything the agent typed is never replaced; they get "Add to notes" instead.
export function summaryMayReplaceNotes({ currentNotes, botSummary, seededText } = {}) {
  const cur = String(currentNotes ?? '');
  if (!cur.trim()) return true;
  if (botSummary && cur === botSummary) return true;
  if (seededText && cur === seededText) return true;
  return false;
}

// "Add to notes": the summary goes below what the agent wrote, never above.
export function appendSummary(currentNotes, text) {
  const cur = String(currentNotes ?? '').replace(/\s+$/, '');
  return cur ? `${cur}\n\n${text}` : text;
}

// One request per contact; any failure resolves to null so wrap-up carries on
// exactly as before (bot-leg summary or empty notes).
export async function fetchContactSummary({ url, contactId, headers, fetchImpl = fetch, timeoutMs = 15000 }) {
  if (!url || !contactId) return null;
  const ctl = typeof AbortController === 'function' ? new AbortController() : null;
  const timer = ctl ? setTimeout(() => ctl.abort(), timeoutMs) : null;
  try {
    const res = await fetchImpl(url, {
      method: 'POST',
      headers,
      body: JSON.stringify({ contactId }),
      ...(ctl ? { signal: ctl.signal } : {}),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok || data.ok === false || !data.summary || !data.text) return null;
    return { summary: data.summary, text: String(data.text) };
  } catch {
    return null;
  } finally {
    if (timer) clearTimeout(timer);
  }
}
